import { request } from "utils/api";

// submit uno dashboard feedback (POST /platform/uno-feedback)
export const postUnoFeedback = (data: {
    consent?: boolean,
    feedback?: string,
    rating?: number,
}) => request<{}>({
    data,
    endpoint: "/platform/uno-feedback",
    method: "post",
});

// submit report to Slack (POST /platform/reports)
export const postReport = (data: {
    context: string,
    request?: string,
    description?: string,
}) => request<{}>({
    data,
    endpoint: "/platform/reports",
    method: "post",
});
